<form>
  <div class="filter-panel">

    <div class="filter-panel-item">
      <mat-form-field>
        <input #municipalityName type="text" [placeholder]="'municipality' | translate" aria-label="Name" matInput
          [formControl]="nameForm" />

        <mat-icon *ngIf="municipalityName.value.length > 0" (click)="nameForm.setValue(''); filterMunicipalities()"
          matSuffix>close</mat-icon>
      </mat-form-field>
    </div>


    <div class="filter-panel-item">
      <mat-form-field>
        <input #municipalityCity type="text" [placeholder]="'city' | translate" aria-label="City" matInput
          [formControl]="cityForm" />

        <mat-icon *ngIf="municipalityCity.value.length > 0" (click)="cityForm.setValue(''); filterMunicipalities()"
          matSuffix>close</mat-icon>
      </mat-form-field>
    </div>

    <div class="filter-panel-item">
      <button mat-raised-button color="primary" mat-raised-button (click)="filterMunicipalities()">
        <mat-icon>search</mat-icon>
        {{ "search" | translate }}
      </button>
    </div>

    <div class="filter-panel-item">
      <button *ngIf="nameForm.value || cityForm.value || countryForm.value" mat-raised-button mat-raised-button
        (click)="clearFilter()">
        {{ "clear" | translate }}
      </button>
    </div>

    <div class="filter-panel-item" *ngIf="isAdministrator">
      <button (click)="addMunicipality()" color="primary" mat-raised-button>
        <mat-icon>add</mat-icon>
        {{ "add" | translate }}
      </button>
    </div>
  </div>
</form>
<table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>{{ "municipality" | translate }}</th>
    <td mat-cell *matCellDef="let element">
      <b>{{ element.name }}</b>
    </td>
  </ng-container>

  <ng-container matColumnDef="city">
    <th class="text-center" mat-header-cell *matHeaderCellDef>
      {{ "city" | translate }}
    </th>
    <td class="text-center" mat-cell *matCellDef="let element">
      {{ element.city }}
    </td>
  </ng-container>

  <ng-container matColumnDef="num-of-buildings">
    <th class="text-center" mat-header-cell *matHeaderCellDef>
      {{ "num-of-buildings" | translate }}
    </th>
    <td class="text-center" mat-cell *matCellDef="let element">
      {{ element.buildings }}
    </td>
  </ng-container>

  <!-- <ng-container matColumnDef="country">
    <th mat-header-cell *matHeaderCellDef>{{ "country" | translate }}</th>
    <td mat-cell *matCellDef="let element">{{ element.country }}</td>
  </ng-container> -->

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">
      <div class="actions-panel">
        <mat-icon *ngIf="isAdministrator" (click)="editMunicipality($event, element)" matTooltip="Edit">edit</mat-icon>
        <mat-icon *ngIf="isAdministrator" (click)="deleteMunicipality($event, element)" matTooltip="Delete">delete
        </mat-icon>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
  <tr mat-row *matRowDef="let element; columns: columnsToDisplay"></tr>
</table>

<mat-paginator #paginator [length]="total" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
  (page)="changePage($event)">
</mat-paginator>
